<template>
  <v-app
    :light="user === null || nightmode === false"
    :dark="user !== null && nightmode"
  >
    <v-navigation-drawer v-model="menuOpen" app fixed temporary>
      <v-toolbar flat>
        <v-list>
          <v-list-tile>
            <v-flex xs4 class="menu-close">
              <a href="#" @click="menuOpen = !menuOpen">
                <img :src="'/img/menu/burger_menu.svg'" />
              </a>
            </v-flex>
            <v-list-tile-title class="title">
              <v-layout>
                <v-flex
                  v-if="user"
                  x8
                  class="text-xs-right grey--text mt-1"
                  style="font-size: 14px;"
                  >{{ user.email }}</v-flex
                >
              </v-layout>
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-toolbar>
      <v-divider></v-divider>
      <v-list dense class="pt-0 ml-4 mt-4">
        <v-list-tile
          v-for="item in menuItems"
          v-if="_.includes(item.roles || ['user'], user ? user.role : null)"
          :key="item.title"
          :to="{ name: item.routeName }"
          exact
          class="mb-2"
        >
          <img
            v-if="$route.name == item.routeName"
            class="select-line"
            :src="'/img/menu/selected_line.svg'"
          />
          <v-list-tile-action
            :class="[
              'title-action',
              $route.name == item.routeName ? 'title-action-margin' : ''
            ]"
          >
            <img
              :src="
                '/img/menu/' +
                  ($route.name == item.routeName
                    ? item.icon + '_selected'
                    : item.icon) +
                  '.svg'
              "
            />
          </v-list-tile-action>
          <v-list-tile-content style="margin-top: 8px; height: 44px;">
            <v-list-tile-title class="menu-item">
              {{ item.title }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile class="mb-2" @click="openHelpCenter()">
          <v-list-tile-action>
            <img :src="'/img/menu/help_center.svg'" />
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="menu-item"
              >Help Center
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile class="mb-2" @click="logout()">
          <v-list-tile-action>
            <img :src="'/img/menu/logout.svg'" />
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="menu-item">Logout</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>

    <v-toolbar ref="toolbar" clipped-left app :flat="this.pageOffset === 0">
      <v-toolbar-side-icon v-if="user" @click="menuOpen = !menuOpen">
        <IconBase icon-name="Menu" height="20" width="28" view-box="0 0 28 20">
          <MenuBurgerDarkIcon v-if="themeDark" />
          <MenuBurgerLightIcon v-else />
        </IconBase>
      </v-toolbar-side-icon>

      <router-link :to="{ name: 'welcome' }">
        <v-toolbar-title style="padding-top: 8px;">
          <img
            :src="
              '/img/favicon_small' +
                (user !== null && nightmode ? '_night' : '') +
                '.svg'
            "
            alt="GSMG"
          />
        </v-toolbar-title>
      </router-link>
      <v-spacer></v-spacer>
      <v-toolbar-items v-if="!user">
        <v-btn
          v-if="visibleFrontLogin"
          flat
          to="/register"
          :class="
            windowWidth < 768
              ? 'btn-register-front-mobile'
              : 'btn-register-front'
          "
        >
          {{ windowWidth < 768 ? "Register" : "Register" }}
        </v-btn>
        <v-btn
          v-else-if="visibleRegister"
          flat
          to="/register"
          class="btn-register"
        >
          Register</v-btn
        >
        <img
          v-if="visibleLogin && visibleRegister"
          :src="'/img/divider.svg'"
          :style="windowWidth < 768 ? 'margin: 0 8px' : 'margin: 0 20px;'"
          alt=""
        />
        <v-btn
          v-if="visibleLogin"
          flat
          to="/login"
          :class="
            windowWidth < 768 && $route.name == 'welcome'
              ? 'btn-login-mobile'
              : 'btn-login'
          "
          >Log in</v-btn
        >
      </v-toolbar-items>
      <v-toolbar-items v-if="user">
        <a class="mt-2 mr-3">
          <img
            :src="
              '/img/dark_mode' +
                (user !== null && nightmode ? '_night' : '') +
                '.svg'
            "
            alt="Nightmode"
            @click="nightmode = !nightmode"
          />
        </a>
        <a v-if="!pendingCount || pendingCount == 0" class="mt-2">
          <img
            :src="
              '/img/notifications_icon_' +
                (user !== null && nightmode ? 'dark' : 'light') +
                '.svg'
            "
            alt="Notifications"
            @click="accountHistoryDialog = !accountHistoryDialog"
          />
        </a>
        <a v-else class="mt-2">
          <img
            :src="
              '/img/notifications_icon_unread_' +
                (user !== null && nightmode ? 'dark' : 'light') +
                '.svg'
            "
            alt="Notifications"
            @click="accountHistoryDialog = !accountHistoryDialog"
          />
        </a>
      </v-toolbar-items>
    </v-toolbar>

    <v-dialog
      v-model="accountHistoryDialog"
      scrollable
      lazy
      :max-width="windowWidth < 537 ? '90%' : '537px'"
      content-class="notifications-dialog"
    >
      <RecentAccountHistory />
    </v-dialog>

    <v-content
      :style="
        headerResize && windowWidth < 768
          ? 'padding-bottom:348px !important'
          : ''
      "
    >
      <child></child>
    </v-content>
    <v-footer v-if="visibleFooter" app height="auto" absolute>
      <v-container
        grid-list-xs
        :class="windowWidth < 768 ? 'footer-container-mob' : 'footer-container'"
      >
        <v-layout row wrap>
          <v-flex md2 lg2 wrap :class="windowWidth < 768 ? 'xs12' : 'xs2'">
            <v-layout>
              <span> © {{ currentYear }} - GSMG </span>
            </v-layout>
            <v-layout>
              <img
                :src="
                  'https://d0.awsstatic.com/logos/powered-by-aws' +
                    (user !== null && nightmode ? '-white' : '') +
                    '.png'
                "
                alt="Powered by AWS Cloud Computing"
                height="30px"
                class="aws"
              />
            </v-layout>
          </v-flex>
          <v-flex v-if="windowWidth > 768" md8 lg8 wrap xs8>
            <v-layout>
              <span>
                <a target="_blank" href="/terms" class="mr-4">
                  General Terms and Conditions
                </a>
              </span>
              <span>
                <a target="_blank" href="/risk" class="mr-4">
                  Risk Disclosure Statement
                </a>
              </span>
              <span>
                <a target="_blank" href="/privacy" class="mr-4">
                  Privacy Policy
                </a>
              </span>
              <span>
                <a target="_blank" href="/yummy" class="mr-4">
                  Cookies Policy
                </a>
              </span>
            </v-layout>
            <v-layout class="mt-2">
              <span>
                GSMG.io and its trading apps issued under GSMG are wholly owned
                and operated by EPIPREMNUM AUREUM LLC, a Saint Kitts and Nevis
                incorporated entity or its relevant authorised affiliates.
              </span>
            </v-layout>
          </v-flex>
          <v-flex v-else md12 lg12 wrap xs12 mt-32>
            <v-layout row wrap>
              <v-flex xs6 md2>
                <a target="_blank" href="/terms" class="mr-4">
                  General Terms and Conditions
                </a>
              </v-flex>
              <v-flex xs6 md2>
                <a target="_blank" href="/risk" class="mr-4">
                  Risk Disclosure Statement
                </a>
              </v-flex>
              <v-flex xs6 md2>
                <a target="_blank" href="/privacy" class="mr-4">
                  Privacy Policy
                </a>
              </v-flex>
              <v-flex xs6 md2>
                <a target="_blank" href="/yummy" class="mr-4">
                  Cookies Policy
                </a>
              </v-flex>
            </v-layout>
            <v-layout class="mt-2">
              <span>
                GSMG.io and its trading apps issued under GSMG are wholly owned
                and operated by EPIPREMNUM AUREUM LLC, a Saint Kitts and Nevis
                incorporated entity or its relevant authorised affiliates.
              </span>
            </v-layout>
          </v-flex>
          <v-flex
            md2
            lg2
            wrap
            class="social-icons"
            :class="
              windowWidth < 768
                ? ['xs12', 'mt-32', 'mb-32']
                : ['xs2', 'text-xs-right']
            "
          >
            <a href="https://t.me/GSMG_Bot" target="_blank">
              <v-icon>fab fa-telegram</v-icon>
            </a>
            <a href="https://gsmg-platform.slack.com" target="_blank">
              <v-icon>fab fa-slack</v-icon>
            </a>
            <a href="https://twitter.com/GSMG_Bot?lang=en" target="_blank">
              <v-icon>fab fa-twitter</v-icon>
            </a>
          </v-flex>
        </v-layout>
      </v-container>
    </v-footer>
    <div v-if="showCookie" id="cookie_banner">
      <div class="container">
        <div class="body">
          <div class="content no-fields">
            <p class="description">
              Cookie consent <br />
              This website uses cookies to help it function properly. These
              cookies are used to optimise and customise your
              customer-experience. Should you continue using this website, then
              we assume that you are okay with that.
              <a href="/yummy" target="_blank"
                >Read more about our cookie policy here.</a
              >
            </p>
            <form class="form valid pristine">
              <div class="buttons">
                <button type="button" class="button" @click="acceptCookie">
                  GOT IT
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </v-app>
</template>

<style lang="scss">
.social-icons i.v-icon.v-icon {
  color: #103a84;
}
.social-icons,
.terms {
  a {
    text-decoration: underline;
    color: inherit;
    margin-left: 10px;
    padding-top: 4px;
  }
}
.v-toolbar__content {
  height: 60px !important;
}
.v-footer {
  font-size: 12px;
}
.theme--light.v-footer {
  background: #ffffff !important;
  color: #7395d0 !important;
}
.theme--light.v-footer a {
  color: #7395d0 !important;
}
.theme--dark.v-footer {
  color: #8691a4;
}
.theme--dark.v-footer a {
  color: #8691a4;
}
.theme--dark.v-footer .social-icons i.v-icon.v-icon {
  color: #8691a4;
}
.theme--light.v-toolbar {
  background-color: #fff;
  box-shadow: 2px 4px 12px rgba(57, 95, 169, 0.1) !important;
}
.theme--dark.v-navigation-drawer {
  background-color: #1c1c1e;
}
.v-navigation-drawer > .v-list .v-list__tile--active .v-list__tile__title {
  background: -webkit-linear-gradient(#468aff, #0051dd);
  background-clip: border-box;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.menu-item {
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 19px;
  color: #8691a4;
}
.select-line {
  margin-left: -20px;
}
.title-action {
  height: 44px;
}
.title-action-margin {
  margin-left: 15px;
}
.menu-close {
  margin-left: 12px;
}
.footer-container {
  height: 148px;
  padding-top: 32px;
}
.footer-container-mob {
  padding-top: 32px;
}
.aws {
  margin-top: 20px;
}
.btn-register {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #468aff !important;
  border: solid 2px;
  border-radius: 30px;
  height: 44px !important;
  width: 196px;
}
.btn-register-front {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #ffffff !important;
  background: linear-gradient(180deg, #468aff 0%, #0051dd 100%);
  border-radius: 30px;
  padding: 10px 25px 10px 25px;
  text-decoration: none;
  height: 44px !important;
  width: 196px;
}
.btn-register-front-mobile {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #ffffff !important;
  background: linear-gradient(180deg, #468aff 0%, #0051dd 100%);
  border-radius: 30px;
  padding: 10px 25px 10px 25px;
  text-decoration: none;
  height: 44px !important;
  width: 116px;
}
.btn-login {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #468aff !important;
  border: solid 2px;
  border-radius: 30px;
  height: 44px !important;
  width: 144px;
}
.btn-login-mobile {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #468aff !important;
  border: solid 2px;
  border-radius: 30px;
  height: 44px !important;
  width: 106px;
}
.mt-32 {
  margin-top: 32px;
}
.mb-32 {
  margin-bottom: 32px;
}

.theme--light .icon-for-information {
  color: #8691a4 !important;
}
.theme--dark .icon-for-information {
  color: #959596 !important;
}
@media (max-width: 960px) {
  .footer-container {
    height: 148px;
    padding-top: 32px;
  }
}
</style>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import scrollMixin from "../mixins/scrollMixin";
import IconBase from "../components/icons/IconBase";
import MenuBurgerLightIcon from "../components/icons/MenuBurgerLightIcon";
import MenuBurgerDarkIcon from "../components/icons/MenuBurgerDarkIcon";
import RecentAccountHistory from "../components/dashboard/RecentAccountHistory";

export default {
  name: "InsightsLayout",
  components: {
    IconBase,
    MenuBurgerLightIcon,
    MenuBurgerDarkIcon,
    RecentAccountHistory
  },
  mixins: [scrollMixin],
  metaInfo() {
    return {
      titleTemplate: "%s | GSMG"
    };
  },
  data: function() {
    return {
      showCookie: true,
      menuOpen: false,
      menuItemsTemp: [
        {
          icon: "dashboard",
          title: "Dashboard",
          routeName: "dashboard",
          roles: ["user", "admin"]
        },
        {
          icon: "settings",
          title: "Settings",
          routeName: "settings",
          roles: ["user", "admin"]
        }
      ],
      nightmode: window.localStorage.getItem("nightmode") === "true",
      currentYear: new Date().getFullYear(),
      windowWidth: window.innerWidth,
      accountHistoryDialog: false
    };
  },
  mounted() {
    this.$intercom.boot({});
    if (this.get_cookie("acceptedCookie")) {
      this.showCookie = false;
    }
    window.onresize = () => {
      this.windowWidth = window.innerWidth;
    };
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      themeDark: "settings/darkmode",
      subscriptionHistory: "auth/userHistory"
    }),
    menuItems() {
      if (this.user) {
        let menu = [
          {
            icon: "dashboard",
            title: "Dashboard",
            routeName: "dashboard",
            roles: ["user", "admin"]
          },
          {
            icon: "settings",
            title: "Settings",
            routeName: "settings",
            roles: ["user", "admin"]
          }
        ];
        return menu;
      }
      return this.menuItemsTemp;
    },
    pendingCount: function() {
      if (this.subscriptionHistory) {
        return this.subscriptionHistory.filter(function(item) {
          return !item.is_read;
        }).length;
      }
      return 0;
    },
    visibleFooter() {
      const pages = ["login", "register", "password.request", "password.reset"];
      return pages.indexOf(this.$route.name) == -1;
    },
    visibleFrontLogin() {
      const pages = ["welcome"];
      return pages.indexOf(this.$route.name) != -1;
    },
    visibleLogin() {
      const pages = ["login"];
      return pages.indexOf(this.$route.name) == -1;
    },
    visibleRegister() {
      return (
        this.$route.name !== "register" &&
        this.$route.name !== "password.request"
      );
    },
    headerResize() {
      const pages = ["login", "register", "password.request", "password.reset"];
      return pages.indexOf(this.$route.name) == -1;
    }
  },
  created: function() {
    this.$store.dispatch("auth/refreshUserHistory");
  },
  methods: {
    checkNotifications() {
      setTimeout(() => {
        if (this.user) {
          this.$store.dispatch("auth/refreshUserHistory");
          this.checkNotifications();
        }
      }, 300000);
    },
    currentRoute() {
      return this.$router.currentRoute.name;
    },
    async logout() {
      await axios.post("/api/v1/logout");
      await this.$store.dispatch("auth/logout");
      window.location.href = "/login";
    },
    downloadFaq() {
      const url = "/faq.pdf";
      window.open(url, "_blank");
    },
    openHelpCenter() {
      const url = "https://intercom.help/gsmg";
      window.open(url, "_blank");
    },
    openGlobalStats() {
      const url = "https://stats.gsmg.io";
      window.open(url, "_blank");
    },
    acceptCookie() {
      var cookie_date = new Date();
      cookie_date.setTime(cookie_date.getTime() + 356 * 24 * 60 * 60 * 1000);
      document.cookie =
        "acceptedCookie=1; expires=" + cookie_date.toGMTString();
      this.showCookie = false;
    },
    get_cookie(cookie_name) {
      var results = document.cookie.match(
        "(^|;) ?" + cookie_name + "=([^;]*)(;|$)"
      );
      if (results) return unescape(results[2]);
      else return null;
    }
  },
  watch: {
    nightmode: function(newMode, oldMode) {
      window.localStorage.setItem("nightmode", newMode);
      this.$store.dispatch("settings/setDarkMode", newMode);
    },
    user: function(newValue, oldValue) {
      if (oldValue == null && newValue) {
        this.checkNotifications();
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/layouts/insights.vue